import { render, staticRenderFns } from "./StartupsAdvancedGrid.vue?vue&type=template&id=3460c9e3&scoped=true&"
import script from "./StartupsAdvancedGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsAdvancedGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460c9e3",
  null
  
)

export default component.exports